import { isEmpty, orderBy, slice } from "lodash";
import { useEffect, useState } from "react";
import { eInteraction, Interaction } from "../../../@types/Interaction";
import {
  Content,
  ReactionsSummary,
  ReactionSummary,
} from "../../../@types/Posts";
import usePostContext from "../../../context/PostContext";
import { reactionsIconsByContent } from "../LikeButton";
import ReactionsDetails from "./ReactionsDetails";

export default function OverviewInteractions() {
  const { interactions } = usePostContext();
  const [reactions, setReactions] = useState<Interaction[]>([]);
  const [comments, setComments] = useState<Interaction[]>([]);
  const [reactionsSummary, setReactionsSummary] = useState<ReactionSummary[]>(
    []
  );
  const [showReactionsModal, setShowReactionsModal] = useState<boolean>(false);
  const threeMoreUsedReactions = slice(reactionsSummary, 0, 3);

  useEffect(() => {
    const newReactionsState = interactions.filter(
      (interaction) => interaction.type === eInteraction.REACTION
    );
    const newCommentsState = interactions.filter(
      (interaction) => interaction.type === eInteraction.COMMENT
    );

    setReactions(newReactionsState);
    setComments(newCommentsState);

    const newReactionsSummary = getReactionsSummary(newReactionsState);
    setReactionsSummary(newReactionsSummary);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interactions]);

  return (
    <div
      style={{
        maxHeight: 5,
        marginTop: 5,
        display: "flex",
      }}
    >
      {!isEmpty(reactions) &&
        threeMoreUsedReactions.map((reactionSummary, i) => {
          if (reactionSummary.qnt > 0) {
            return (
              <span
                className="mg-b-5"
                style={{ cursor: "pointer", maxHeight: 17, maxWidth: 17 }}
                key={i}
                onClick={() => setShowReactionsModal(true)}
              >
                {reactionSummary.icon}
              </span>
            );
          }

          return <span key={i}></span>;
        })}

      <span>
        <span
          className="mg-l-5 cursor-pointer tx-medium tx-11"
          onClick={() => setShowReactionsModal(true)}
        >
          {!isEmpty(reactions) && `${reactions.length}`}
        </span>

        <span style={{ position: 'absolute', right: 10, maxHeight: 5 }}>
          {!isEmpty(comments) && `${comments.length} comentários`}
        </span>
      </span>

      <ReactionsDetails
        show={showReactionsModal}
        onHide={() => {
          setShowReactionsModal(false);
        }}
      />
    </div>
  );
}

/**
 * Get reactions ordered by quantity.
 * @param reactions
 */
function getReactionsSummary(reactions: Interaction[]): ReactionSummary[] {
  const reactionsSummary: ReactionsSummary = {
    love: {
      qnt: 0,
      items: [],
      icon: reactionsIconsByContent.love.smallChecked,
    },
    funny: {
      qnt: 0,
      items: [],
      icon: reactionsIconsByContent.funny.smallChecked,
    },
    cry: {
      qnt: 0,
      items: [],
      icon: reactionsIconsByContent.cry.smallChecked,
    },
    up: {
      qnt: 0,
      items: [],
      icon: reactionsIconsByContent.up.smallChecked,
    },
    down: {
      qnt: 0,
      icon: reactionsIconsByContent.down.smallChecked,
      items: [],
    },
  };

  reactions.forEach((reaction) => {
    const contents: Content[] = ["love", "funny", "cry", "up", "down"];

    contents.forEach((content: Content) => {
      if (content === reaction.content) {
        reactionsSummary[content].qnt++;
        reactionsSummary[content].items.push(reaction);
      }
    });
  });

  return orderBy(reactionsSummary, (reaction) => reaction.qnt, "desc");
}
